import { useContext } from 'react';
import { TableContext } from '../../Table.context';
import { A, Wrapper } from './CellLink.style';

export type CellLinkProps = {
  value: string;
  itemId: string;
};

export function CellLink(props: CellLinkProps) {
  const { value, itemId } = props;
  const { callbacks, config } = useContext(TableContext);

  function onClick() {
    callbacks.onAction({ type: config.misc.actionType, verb: 'open', id: itemId });
  }

  return (
    <Wrapper className='CellLink-wrapper' data-testid='CellLink-wrapper'>
      <A onClick={onClick}>{value}</A>
    </Wrapper>
  );
}

export default CellLink;
